/**
 * PULSE UI — shared interactive bits
 * ------------------------------------------------------------
 * Delegated listeners on document, so everything keeps working
 * after shell navigations that swap #MainContent.
 */
(function(){

  /* FAQ accordions */
  document.addEventListener('click', function(e){
    var q = e.target.closest('.faq-q');
    if(!q) return;
    var item = q.closest('.faq-item');
    if(item) item.classList.toggle('is-open');
  });

  /* Review filter chips (visual state only) */
  document.addEventListener('click', function(e){
    var chip = e.target.closest('.filter-chip');
    if(!chip || !chip.parentElement) return;
    chip.parentElement.querySelectorAll('.filter-chip').forEach(function(c){
      c.classList.remove('is-active');
    });
    chip.classList.add('is-active');
  });

  /* Smooth-scroll nudges — offset for the fixed header so the
     target doesn't land underneath it. */
  function headerOffset(){
    var nav = document.querySelector('.site-nav');
    return (nav ? nav.offsetHeight : 0) + 20;
  }

  document.addEventListener('click', function(e){
    var el = e.target.closest('[data-scroll-to]');
    if(!el) return;
    e.preventDefault();

    var id = el.getAttribute('data-scroll-to');
    var target = document.getElementById(id);
    if(!target){
      console.warn('PULSE: scroll target not found:', id);
      return;
    }

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset();

    window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });

    target.classList.add('is-highlighted');
    setTimeout(function(){ target.classList.remove('is-highlighted'); }, 2400);
  });

})();
